module.exports = __webpack_public_path__ + "static/media/blog-single-illustration.c78038ba.svg";